import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import CreateTenantForm from './create-tenant-form'
import { atom } from 'jotai'

interface TenantButtonProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const createTenantModalAtom = atom(false)

export default function CreateTenantModal({ open, onOpenChange }: TenantButtonProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Adicionar Empresa</DialogTitle>
          <DialogDescription>Formulários de Cadastro</DialogDescription>
        </DialogHeader>
        <div className="max-h-[600px] overflow-y-auto">
          <CreateTenantForm />
        </div>
      </DialogContent>
    </Dialog>
  )
}
